import {onlineServiceUrl,purchaseShoppingOnlineServiceUrl} from '../api/config.js'
/** 7moorInit.js 中使用的变量 */


export function setQimoClientId() {
    let userInfo = JSON.parse(localStorage.getItem("USERINFO") || '{}') ;
 
    if (userInfo.companyId) {
        window.qimoClientId = {
            userId: userInfo.memberId,
            nickName: userInfo.companyName,
            customField: {
                "appId": "201",
                "companyId": userInfo.companyId,
                "companyName": userInfo.companyName,
                "account": userInfo.memberName
            }
        };
    } else {
        window.qimoClientId = {
            userId: userInfo.memberId,
            nickName: userInfo.realName||userInfo.memberName,
            customField: {
                "appId": "201",
                "companyId": userInfo.memberId,
                "companyName": userInfo.realName||userInfo.memberName,
                "account": userInfo.memberName
            }
        };
    }
}


/**
 * 在线客服窗口
 * 初始化在线客服js脚本
 *    let qimoClientId = {
 *       userId: '', 登录用户：会员id  非登录用户：youke+随机生成数3位+时间戳（精确至毫秒）
 *       nickName:'', 登录用户：企业会员--公司名称，个人会员：个人昵称 或 登录帐号
 *       customField: {
 *           "appId":"201",(固定值)
 *           "companyId":"",
 *           "companyName": "",
 *           "account":""
 *       }
 *   };
 *   <script type='text/javascript' src='http://10.248.68.250:9916/javascripts/7moorInit.js?accessId=27b7d800-2f5b-11e9-bed6-9f6dfd4beaf7&autoShow=true&language=ZHCN' async='async'/>
 */
export function initSource() {

    //判断2.0 和 易专采   purchaseAreaFlag为true 是易专采，false 是2.0   ,
    let userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    let sources = [{
        element: 'script',
        type: "text/javascript",
        url:  userInfo.purchaseAreaFlag ? purchaseShoppingOnlineServiceUrl :onlineServiceUrl ,
        async: 'async'
    }];
    for (let i = 0; i < sources.length; i++) {
        let ele = document.createElement(sources[i].element);
        if (sources[i].element == 'script') {
            ele.type = sources[i].type;
            ele.src = sources[i].url;
            ele.async = sources[i].async;
            ele.scriptType = '1'
        }
        document.getElementsByTagName('head')[0].appendChild(ele)
    }
}
